import { Component, OnInit, Input, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { TipoCertificadoService } from './tipo_certificado.service';
import { TipoCertificado } from './tipo_certificado';
import { GrupoService } from './../grupos/grupo.service';
import { Grupo } from './../grupos/grupo';
import { TipoService } from './../tipos/tipo.service';
import { Tipo } from './../tipos/tipo';

import { VariavelPadrao } from './variaveis_padroes';

declare var Materialize:any;


@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  providers: [TipoCertificadoService, GrupoService, TipoService]
})
export class FormTiposCertificadosComponent implements OnInit, AfterViewChecked  {
  public busy: Promise<any>;
  tipo_certificado: TipoCertificado;
  tipos: Tipo[];
  grupos: Grupo[];
  titulo: string = "Tipo Certificados";
  public options: Object = {
                    placeholderText: 'Edit Your Content Here!',
                    charCounterCount: false
                  }
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private tipoCertificadoService: TipoCertificadoService,
    private tipoService: TipoService,
    private grupoService: GrupoService
  ) {
    this.tipo_certificado = new TipoCertificado();
  }

  getTipoCertificado(): void {
    this.route.params.forEach((params: Params) => {
      let id = params['id'];

      if(id !== undefined ){
        this.busy = this.tipoCertificadoService.getTipoCertificado(id)
          .then(tipoCertificado => this.tipo_certificado = tipoCertificado );
      }
    });
  }

  getGrupos(): void{
    this.grupoService.getAllGrupos()
        .then((response) => this.grupos = response);
  }

  upload(event: any):void{
    let listaArquivo: FileList = event.target.files;
    let arquivo: File = listaArquivo[0];
    this.tipo_certificado.background = arquivo;
  }

  removeVariavel(variavel: any): void{
    let indice = this.tipo_certificado.variaveis_padroes.indexOf( variavel );
    console.log(indice);
    this.tipo_certificado.variaveis_padroes[indice].destroy = true;
    console.log(this.tipo_certificado.variaveis_padroes);
    if(!this.tipo_certificado.variaveis_padroes[indice].id){
      this.tipo_certificado.variaveis_padroes.splice(indice, 1);
    }

  }

  addVariavel(): void{
    this.tipo_certificado.variaveis_padroes.push(new VariavelPadrao());
  }


  salvar(): void {

  this.busy = this.tipoCertificadoService.saveTipoCertificado(this.tipo_certificado)
            .then(() => this.goBack());

  }

  goBack(): void {
     this.router.navigate(['/tipoCertificados']);
  }

  getTipos(): void{
    this.tipoService.getTipos()
        .then((response) => this.tipos = response);
  }

  ngOnInit() {
    this.getTipoCertificado();
    this.getGrupos();
    this.getTipos();
  }

  onSelect(): void{
    console.log(this.tipo_certificado);
  }

  ngAfterViewChecked() {
    if(this.tipo_certificado.id != undefined)
      Materialize.updateTextFields();
  }

}



// WEBPACK FOOTER //
// ./src/app/tipos_certificados/form.component.ts